import React from 'react'
import { Form } from '@themesberg/react-bootstrap'
import useStudioFilter from './useStudioFilter'

/**
 * Studio filter component for filtering casino studios
 * @param {Object} props - Component properties
 * @param {boolean} props.isTenantRoute - Flag indicating if the current route is a tenant route
 * @param {string} props.selectedAggregator - Currently selected aggregator ID
 * @param {string} props.selectedProvider - Currently selected provider ID
 * @param {Function} props.onChangeStudio - Callback function triggered when studio selection changes
 * @returns {JSX.Element} Studio filter component
 */

const StudioFilter = ({ isTenantRoute, selectedAggregator, selectedProvider, onChangeStudio }) => {
  const { selectedStudio, setSelectedStudio, filteredStudios } = useStudioFilter({
    isTenantRoute,
    selectedAggregator,
    selectedProvider
  })

  // Handle studio selection change
  const handleStudioChange = (value) => {
    setSelectedStudio(value)
    // Call the callback function to notify parent component
    if (onChangeStudio) {
      onChangeStudio(value)
    }
  }

  return (
    <>
      <Form.Label style={{ marginRight: '15px', marginBottom: '0px' }}>
        Studio
      </Form.Label>

      <Form.Select
        onChange={(e) => {
          handleStudioChange(e.target.value)
        }}
        value={selectedStudio}
        style={{ maxWidth: '230px', marginRight: '15px' }}
        size='sm'
      >
        <option value=''>
          All
        </option>

        {filteredStudios.length === 0 && (
          <option value='' disabled>
            No Studios Available
          </option>
        )}

        {filteredStudios.map(({ casinoStudioId, name }) => (
          <option key={casinoStudioId} value={casinoStudioId}>
            {name}
          </option>
        ))}
      </Form.Select>
    </>
  )
}

export default StudioFilter
